import config from '../config';
import MPUtils from '../utils/MPUtils';

let soundManager;
let dataManager;

class Score extends Phaser.Scene {
  init () {
    // console.log('Score.init');
    let g = this;
    soundManager = g.scene.get('SoundManager');
    soundManager.playMusic('loop-end');

    dataManager = g.sys.game.dataManager;

    dataManager.saveCoins();
    dataManager.checkHighScore();

    dataManager.setSessionItem('collectableCount', 0);

    dataManager.setSessionItem(config.BASE_SCENE, 'Score');

    dataManager.setSessionItem('continueAvailable', true);

    this.viewport = new Phaser.Structs.Size(this.scale.width, this.scale.height, this.game.scale.scaleMode);
    this.viewport.setAspectRatio(this.scale.parentSize.aspectRatio);
  }
  create () {
    // console.log('Score.create');
    let g = this;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      // console.log('On Score Resume');
      soundManager.resumeMusic();
    });

    g.add.sprite(config.CENTER_X, config.CENTER_Y, 'score-bg');

    let bears = g.add.sprite(config.CENTER_X - 5, config.CENTER_Y - 132, 'score-bears');
    bears.setFrame('end-game-bears_00.png');

    let poof = g.add.sprite(config.CENTER_X - 5, config.CENTER_Y - 132, 'score-poof-animate');
    poof.setVisible(false);

    g.time.delayedCall(250, () => {
      bears.play('score-bears-animate');
      poof.play('score-poof-animate');
    });
 
    this.settingsBtn = g.add.sprite(config.WIDTH - 60, config.CENTER_Y - (Math.min(this.viewport.height, this.scale.height) * 0.5) + 60, 'common');
    this.settingsBtn.setFrame('gear-icon-a.png');
    this.settingsBtn.setInteractive();
    this.settingsBtn.on('pointerdown', () => {
      g.scene.launch('Settings');
    });

    let gameOverText = g.add.text(config.CENTER_X, config.CENTER_Y - 420, g.sys.game.localisationManager.GetString("game_over"), { fontFamily: '"FredBurger Black"', fontSize: 102 +"px", color: "#db433e" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(gameOverText, 600, 1000);

    let gameOverTextDesc = g.add.text(config.CENTER_X, config.CENTER_Y - 320, g.sys.game.localisationManager.GetString("game_over_desc"), { fontFamily: '"FredBurger Black"', fontSize: 54 +"px", color: "#FFF", align: 'center', wordWrap: { width: 600 }}).setOrigin(0.5).setStroke('#000', 3)
    gameOverTextDesc.setLineSpacing(-20);
    MPUtils.ClampTextToDimensions(gameOverTextDesc, gameOverTextDesc.style.wordWrapWidth, 1000);

    let tape = g.add.sprite(config.CENTER_X, config.CENTER_Y + 260, 'end-tape');
    tape.play('end-tape-animate');

    let finalText = g.add.text(tape.x - 130, tape.y - 90, g.sys.game.localisationManager.GetString("final_score"), { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(finalText, 240, 1000);

    finalText.setAlpha(0);
    let scoreValue = dataManager.getScore();

    let finalScoreText = g.add.text(finalText.x, finalText.y + 38, scoreValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 48 +"px", color: "#db433e" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(finalScoreText, 240, 1000);
    finalScoreText.setAlpha(0);

    let earnedText = g.add.text(tape.x + 130, tape.y - 90, g.sys.game.localisationManager.GetString("coins_earned"), { fontFamily: '"FredBurger Black"', fontSize: 34 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(earnedText, 240, 1000);

    earnedText.setAlpha(0);
    let coin = g.add.sprite(earnedText.x + 10, earnedText.y + 38, 'common');
    coin.setFrame('coin-b.png');
    coin.setOrigin(1, 0.5);
    coin.setAlpha(0);
    let coinValue = dataManager.getCoins();

    let coinCountText = g.add.text(earnedText.x, earnedText.y + 38, coinValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 48 +"px", color: "#f8df1d" }).setOrigin(0, 0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(coinCountText, 240, 1000);
    coinCountText.setAlpha(0);
    g.children.bringToTop(earnedText);

    // TODO: Hook up best score
    let highScoreValue = dataManager.getHighScore();

    let bestText = g.add.text(config.CENTER_X - 130, tape.y + 20, g.sys.game.localisationManager.GetString("best"), { fontFamily: '"FredBurger Black"', fontSize: 22 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 2)
    MPUtils.ClampTextToDimensions(bestText, 200, 1000);
    bestText.setAlpha(0);

    let bestScoreText = g.add.text(bestText.x, bestText.y + 30, highScoreValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(bestScoreText, 200, 1000);
    bestScoreText.setAlpha(0);

    let boardsCleared = g.add.text(config.CENTER_X + 130, tape.y + 20, g.sys.game.localisationManager.GetString("boards_cleared"), { fontFamily: '"FredBurger Black"', fontSize: 22 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 2)
    MPUtils.ClampTextToDimensions(boardsCleared, 250, 1000);
    let boardsClearedValue = dataManager.getSessionItem('boardsCleared');
    dataManager.setSessionItem('boardsCleared', 0);

    let boardsClearedText = g.add.text(boardsCleared.x, boardsCleared.y + 30, boardsClearedValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(boardsClearedText, 250, 1000);

    boardsClearedText.setAlpha(0);

    g.tweens.add({
      targets: [finalText, finalScoreText, earnedText, coin, coinCountText, bestText, bestScoreText, boardsClearedText],
      alpha: 1,
      duration: 250
    });

    let playBtn = g.add.sprite(config.CENTER_X, config.CENTER_Y + 395, 'common');
    playBtn.setFrame('play-icon-c.png');
    playBtn.setInteractive();
    playBtn.on('pointerdown', () => {
      dataManager.setScore(0);
      g.scene.start('Play', { fixedHighScore: false, replayLevel: false, isNewGame: true });
      soundManager.playSound('play-button');
    });

    soundManager.playSound('tape');
    g.time.delayedCall(300, () => {
      soundManager.playSound('tape');
    });
    g.time.delayedCall(600, () => {
      soundManager.playSound('tape');
    });

    this.scale.on("resize", this.OnResize, this);
  }

  OnResize(){
    this.viewport.setAspectRatio(this.scale.parentSize.aspectRatio);
    this.settingsBtn.y = config.CENTER_Y - (Math.min(this.viewport.height, this.scale.height) * 0.5) + 60;
  }
}

export default Score;
